import { getMessages } from '../../../../../store/constants';

export const TYPE_SWITCHER_CARD_PREVIEW_SETTINGS_HINT = getMessages().getText('type_switcher.preview_settings.hint');
